import { createSlice } from "@reduxjs/toolkit";

export const strategyTypesSlice = createSlice({
    name: "strategyTypes",
    initialState: { strategyTypes: null },
    reducers: {
        setStrategyTypes: (state, action) => {
            state.strategyTypes = action.payload;
        },
        updateStrategyTypes: (state, action) => {
            const strategyTypes = action.payload;
            
            if (state.strategyTypes == null || state.strategyTypes == undefined) {
                state.strategyTypes = strategyTypes;
                return;
            }

            strategyTypes.forEach(strategyType => {
                const strategyTypeIndex = state.strategyTypes.findIndex((st) => st.id === strategyType.id);
                
                if (strategyTypeIndex !== -1) {
                    state.strategyTypes[strategyTypeIndex] = strategyType;
                } else {
                    state.strategyTypes.push(strategyType);
                }
            });

        },
        updateStrategyType: (state, action) => {
            const strategyType = action.payload;
            
            if (state.strategyTypes == null || state.strategyTypes == undefined) {
                state.strategyTypes = [strategyType];
                return;
            }

            const strategyTypeIndex = state.strategyTypes.findIndex((st) => st.id === strategyType.id);

            if (strategyTypeIndex !== -1) {
                state.strategyTypes[strategyTypeIndex] = strategyType;
            } else {
                state.strategyTypes.push(strategyType);
            }

        }
    }
});

export default strategyTypesSlice.reducer;

export const selectAllStrategyTypes = state => state.strategyTypesSlice?.strategyTypes;
export const getStrategyTypeById = (state, id) => state.strategyTypesSlice.strategyTypes?.find(st => st.id === id);

export const {
    setStrategyTypes,
    updateStrategyTypes,
    updateStrategyType
} = strategyTypesSlice.actions;
